import Button from "@client/controls/Button/component";
import { IconType } from "@client/types";
import classnames from "classnames";
import * as React from "react";
import { getPageFromHash, getPaginationInfo, isValidPage, type PaginationInfo } from "./lib";
import "./style.less";

export interface ContentPaginationMapProps {
  page: number;
  total: number;
}

export interface ContentPaginationActionProps {
  onPageClick: (page: number) => void;
}
export type ContentPaginationProps = ContentPaginationActionProps & ContentPaginationMapProps;

class ContentPagination extends React.Component<ContentPaginationProps> {
  public componentDidMount() {
    window.addEventListener("hashchange", this._onHashChange);
  }

  public componentWillUnmount(): void {
    window.removeEventListener("hashchange", this._onHashChange);
  }

  public render() {
    const pi = getPaginationInfo(this.props.page, this.props.total);
    if (pi.pageNumbers.length === 1 && !pi.isLeftArrowAvailable && !pi.isRightArrowAvailable) return null;

    return (
      <div className="wsc_content_pagination">
        <ul>
          {this._renderLeftArrow(pi)}
          {pi.pageNumbers.map((pn) => (
            <li key={pn} className={classnames({ active: pn === pi.currentPage })}>
              <a href={`#page${pn}`}>{pn}</a>
            </li>
          ))}
          {this._renderRightArrow(pi)}
        </ul>
      </div>
    );
  }

  private _onHashChange = () => {
    const page = getPageFromHash();
    page && isValidPage(page, this.props.total) && this.props.onPageClick(page);
  };

  private _renderLeftArrow = (pi: PaginationInfo) => {
    return (
      <li className={classnames({ invisible: !pi.isLeftArrowAvailable })}>
        <a href={`#page${pi.currentPage - 1}`} aria-label="Previous">
          <span aria-hidden="true">
            <i className="far fa-angle-left" />
          </span>
        </a>
      </li>
    );
  };

  private _renderRightArrow = (pi: PaginationInfo) => {
    return (
      <li className={classnames({ invisible: !pi.isRightArrowAvailable })}>
        <a href={`#page${pi.currentPage + 1}`} aria-label="Next">
          <span aria-hidden="true">
            <i className="far fa-angle-right" />
          </span>
        </a>
      </li>
    );
  };
}

export default ContentPagination;

export interface PreviousNextPagerProps {
  pageNumber: number;
  pageSize: number;
  onPreviousClick?: () => void;
  onNextClick?: () => void;
}
export const ContentPreviousNextPagination = (props: PreviousNextPagerProps) => (
  <div className="wsc_content_pagination">
    <Button
      iconClassName={IconType.ChevronLeft}
      isDisabled={!props.onPreviousClick}
      onClick={props.onPreviousClick ? (e) => props.onPreviousClick!() : undefined}
      className="btn-link"
    />
    <Button
      iconClassName={IconType.ChevronRight}
      isIconAfter
      isDisabled={!props.onNextClick}
      onClick={props.onNextClick ? (e) => props.onNextClick!() : undefined}
      className="btn-link"
    />
  </div>
);
